<template>
  <div class="activity-info-container">
    <!-- 页面标题 -->
    <div class="page-header">
      <h2>活动弹窗管理</h2>
    </div>

    <!-- 查询表单 -->
    <el-form :inline="true" :model="queryForm" class="query-form">
      <el-form-item label="门店">
        <el-select
            v-model="queryForm.storeId"
            placeholder="选择店铺"
            clearable
            @change="handleQuery"
            filterable
        >
          <el-option
              v-for="item in storelist"
              :key="item.id"
              :label="item.storename"
              :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select
          v-model="queryForm.status"
          placeholder="请选择状态"
          clearable
          @clear="handleQuery"
        >
          <el-option label="正常" value="0"></el-option>
          <el-option label="失效" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery">
          查询
        </el-button>
        <el-button icon="el-icon-refresh" @click="handleReset">
          重置
        </el-button>
        <el-button type="success" icon="el-icon-plus" v-permission="'btn:activityInfo:add'" @click="handleAdd">
          新增
        </el-button>
      </el-form-item>
    </el-form>

    <!-- 数据表格 -->
    <el-table
      v-loading="loading"
      :data="activityList"
      border
      stripe
      height="700"
      style="width: 100%"
    >
      <el-table-column label="序号" width="80" align="center" type="index">
        <template slot-scope="scope">
          {{(queryForm.page - 1) * queryForm.limit + scope.$index + 1}}
        </template>
      </el-table-column>
      <el-table-column prop="type" label="类型" width="200" align="center">
        <template slot-scope="scope">
          <el-tag type="primary" v-if="scope.row.type === '0'">门店弹窗</el-tag>
          <el-tag type="success" v-else-if="scope.row.type === '1'">全局弹窗</el-tag>
          <el-tag type="warning" v-else>歇业弹窗</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="contentType" label="内容类型" width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="warning" v-if="String(scope.row.contentType) === '2'">文本</el-tag>
          <el-tag type="info" v-else>海报</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="storename" label="门店" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.storename">{{scope.row.storename}}</span>
          <span v-else>全部门店</span>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="点击跳转" width="150" align="center">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.isTz === '1'">是</el-tag>
          <el-tag type="danger" v-else>否</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="jumpUrl" label="跳转链接" min-width="180" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.jumpUrl">{{scope.row.jumpUrl}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="有效时间"  align="center">
        <template slot-scope="{row}">
          <span v-if="row.startDate">{{formateDate(row.startDate)}} ~ {{formateDate(row.endDate)}}</span>
          <span v-else>永久有效</span>
        </template>
      </el-table-column>
      <el-table-column label="歇业时间"  align="center">
        <template slot-scope="{row}">
          <span v-if="row.tyStartDate">{{formateTyDate(row.tyStartDate)}} ~ {{formateTyDate(row.tyEndDate)}}</span>
          <span v-else>无</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="120" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === '0' ? 'success' : 'danger'">
            {{ scope.row.status === '0' ? '正常' : '失效' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="text"
            icon="el-icon-edit"
            v-permission="'btn:activityInfo:edit'"
            @click="handleEdit(scope.row)">
            编辑
          </el-button>
          <el-button
            type="text"
            icon="el-icon-delete"
            v-permission="'btn:activityInfo:delete'"
            style="color: #f56c6c"
            @click="handleDelete(scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="queryForm.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 20px; text-align: right"
    />

    <!-- 添加/编辑对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
      :close-on-click-modal="false"
      @close="handleDialogClose"
    >
      <el-form
        ref="activityForm"
        :model="activityForm"
        :rules="formRules"
        label-width="120px"
      >
        <el-form-item label="活动类型" prop="type">
          <el-radio-group v-model="activityForm.type" @change="handleTypeChange">
            <el-radio label="0">门店弹窗</el-radio>
            <el-radio label="1">全局弹窗</el-radio>
            <el-radio label="2">歇业弹窗</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="门店" prop="storeId" v-if="activityForm.type == '0' || activityForm.type == '2'">
          <el-select
              v-model="activityForm.storeId"
              placeholder="选择门店"
              filterable
              style="width: 100%"
              multiple>
            <el-option
                v-for="item in storelist2"
                :key="item.id"
                :label="item.storename"
                :value="item.id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="有效时间" prop="startDate">
          <el-date-picker
              v-model="validDate"
              type="daterange"
              clearable
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="歇业时间" prop="tyStartDate" v-if="activityForm.type === '2'">
          <el-date-picker
              v-model="tyValidDate"
              type="daterange"
              clearable
              value-format="MM:dd"
              format="MM月dd日"
              @change="tyChange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="弹窗内容" prop="contentType">
          <el-radio-group v-model="activityForm.contentType" @change="handleContentTypeChange">
            <el-radio label="1">海报</el-radio>
            <el-radio label="2">文本</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="海报" prop="hbUrl" v-if="activityForm.contentType == '1'">
          <el-upload
              ref="imgBroadcastUpload"
              :limit="1"
              :auto-upload="true"
              :file-list="fileList"
              :on-success="addPic"
              :on-remove="removePic"
              :on-exceed="handleExceed"
              :before-upload="beforeUpload"
              list-type="picture-card"
              accept="image/jpg, image/png, image/jpeg"
              :data="{storeId: activityForm.storeId.join(',')}"
              :action="uploadurl">
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="文本" prop="content" v-if="activityForm.contentType == '2'">
          <div class="editor-box">
            <div class="editor-tools">
              <el-popover placement="bottom-start" width="330" trigger="click">
                <div class="emoji-panel">
                  <span
                      v-for="emoji in emojiList"
                      :key="emoji"
                      class="emoji-item"
                      @click="insertEmoji(emoji)">{{emoji}}</span>
                </div>
                <el-button slot="reference" size="mini" type="text">😊 插入表情</el-button>
              </el-popover>
              <span class="editor-tip">支持加粗、标题、列表等排版，不支持图片</span>
            </div>
            <quill-editor
                ref="contentEditor"
                v-model="activityForm.content"
                :options="editorOption"></quill-editor>
          </div>
        </el-form-item>
        <el-form-item label="是否跳转" prop="isTz">
          <el-radio-group v-model="activityForm.isTz" @change="handleTzChange">
            <el-radio label="0">否</el-radio>
            <el-radio label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="会员卡" prop="cardId" v-if="activityForm.isTz == '1'">
          <el-select v-model="activityForm.cardId"  placeholder="请选择会员卡" style="width:300px">
            <el-option v-for="item in cardlist" :key="item.id" :label="'【' + (item.cardScopeType == '1' ? '单店卡' : item.cardScopeType == '2' ? '城市通卡' : item.cardScopeType == '3' ? '全国通卡' : '自定义通卡') + '】' + item.cardname+' （'+item.days + '）'" :value="item.cardid"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="赠送天数" prop="zsDay" v-if="activityForm.isTz == '1'">
          <el-input v-model="activityForm.zsDay"></el-input>
        </el-form-item>
        <el-form-item label="跳转链接" prop="jumpUrl">
          <el-input v-model="activityForm.jumpUrl" placeholder="小程序页面路径，如 pages/coach/coach"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="handleSubmit">
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ActivityInfo',
  data() {
    return {
      cardlist: [],
      ossURL: this.ossURL,
      // 查询表单
      queryForm: {
        page: 1,
        limit: 10,
        storeId: '',
        status: ''
      },
      validDate: [],
      tyValidDate: [],
      // 活动列表
      activityList: [],
      storelist: [],
      storelist2: [],
      // 总记录数
      total: 0,
      // 加载状态
      loading: false,
      // 对话框显示状态
      dialogVisible: false,
      // 对话框标题
      dialogTitle: '',
      // 提交加载状态
      submitLoading: false,
      // 活动表单
      activityForm: {
        id: null,
        storeId: [],
        startDate: '',
        endDate: '',
        tyStartDate: '',
        tyEndDate: '',
        status: '0',
        hbUrl: '',
        contentType: '1',
        content: '',
        type: '0',
        isTz: '0',
        cardId: null,
        zsDay: null,
        jumpUrl: ''
      },
      // 表单验证规则
      formRules: {
        storeId: [
          { required: true, message: '请选择门店', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ],
        contentType: [
          { required: true, message: '请选择弹窗内容类型', trigger: 'change' }
        ],
        hbUrl: [
          { required: true, message: '请上传海报', trigger: 'blur' }
        ],
        content: [],
        type: [
          { required: true, message: '请选择类型', trigger: 'change' }
        ],
        cardId: [],
        tyStartDate: [],
        zsDay: []
      },
      fileList: [],
      uploadurl: this.GLOBAL.imgURL+'uploadHb/',
      // 富文本配置：只保留文字排版能力，不提供插图。
      // 注意：对齐/字号/缩进在 quill 里是 class（ql-align-center 等），小程序 rich-text 不加载
      // quill 的 CSS 会失效，故不开放；保留的都是能落成标签或内联 style 的排版。
      editorOption: {
        placeholder: '请输入弹窗文本内容，支持加粗、标题、列表等排版',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'color': [] }, { 'background': [] }],
            ['clean']
          ]
        }
      },
      // 常用表情
      emojiList: [
        '😀', '😄', '😁', '😆', '😅', '😂', '🤣', '😊', '😍', '🥰',
        '😘', '😎', '🤔', '😐', '😢', '😭', '😡', '👍', '👎', '👏',
        '🙏', '💪', '🎉', '🎊', '❤️', '💖', '🔥', '⭐', '✨', '💰',
        '🎁', '🏋️', '🏃', '🥇', '📢', '📌', '✅', '❌', '⚠️', '⏰'
      ],
    }
  },
  created() {
    this.getActivityList()
    this.GetStore()
    this.GetCardList()
  },
  methods: {
    formateDate(dat) {
      if (!this.isLikelyTimestamp(dat)) {
        dat = new Date(dat)
      }

      let month = dat.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }

      let day = dat.getDate()
      if (day < 10) {
        day = '0' + day
      }

      return dat.getFullYear() + '-' + month + '-' + day
    },
    formateTyDate(dat) {
      let arr = dat.split(":")

      return arr[0] + '月' + arr[1] + '日'
    },
    isLikelyTimestamp(value) {
      return typeof value === 'number' &&
          value > 0 &&
          value < 9999999999999; // 防止误判普通数字
    },
    async GetStore() {
      const { data: res } = await this.$http.get("store/");
      if (res.status == 0) {
        this.storelist = res.data;
      }
    },
    async GetCardList() {
      const { data: res } = await this.$http.get("cardXlk/");
      console.log(res)
      this.cardlist = res;
    },
    async GetStore2(storeId) {
      this.storelist2 = []
      const { data: res } = await this.$http.post("activity/store",{storeId: storeId});
      if (res.status == 0) {
        this.storelist2 = res.data;
      }
    },
    // 获取活动列表
    getActivityList() {
      this.loading = true
      const params = {
        page: this.queryForm.page,
        limit: this.queryForm.limit
      }

      // 添加可选查询参数
      if (this.queryForm.storeId) {
        params.storeId = this.queryForm.storeId
      }
      if (this.queryForm.status) {
        params.status = this.queryForm.status
      }

      // 使用 axios 发送请求
      this.$http.get('/activity/list', { params })
        .then(response => {
          let data = response.data;
          if (data.code === 200) {
            this.activityList = data.data.list || []
            this.total = data.data.total || 0
          } else {
            this.$message.error(data.msg || '获取活动列表失败')
          }
        })
        .catch(error => {
          console.error('获取活动列表失败:', error)
          this.$message.error('获取活动列表失败，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },

    // 查询
    handleQuery() {
      this.queryForm.page = 1
      this.getActivityList()
    },

    // 重置
    handleReset() {
      this.queryForm = {
        page: 1,
        limit: 10,
        storeId: '',
        status: ''
      }
      this.getActivityList()
    },

    // 新增
    handleAdd() {
      this.dialogTitle = '新增活动'
      this.dialogVisible = true
      this.activityForm = {
        id: null,
        storeId: [],
        startDate: '',
        endDate: '',
        tyStartDate: '',
        tyEndDate: '',
        status: '0',
        hbUrl: '',
        contentType: '1',
        content: '',
        type: '0',
        isTz: '0',
        cardId: null,
        zsDay: null,
        jumpUrl: ''
      }
      this.validDate = []
      this.fileList = []
      this.handleContentTypeChange('1')
      this.GetStore2()
    },

    // 编辑
    handleEdit(row) {
      this.dialogTitle = '编辑活动'
      this.dialogVisible = true
      let storeIds = []
      let arr = row.storeId.split(',')
      arr.forEach(item => {
        storeIds.push(parseInt(item))
      })

      this.activityForm = {
        id: row.id,
        storeId: storeIds,
        startDate: row.startDate,
        endDate: row.endDate,
        status: row.status,
        hbUrl: row.hbUrl,
        contentType: String(row.contentType || 1),
        content: row.content || '',
        type: row.type,
        tyStartDate: row.tyStartDate,
        tyEndDate: row.tyEndDate,
        isTz: row.isTz,
        cardId: row.cardId,
        zsDay: row.zsDay,
        jumpUrl: row.jumpUrl || ''
      }
      this.fileList = row.hbUrl ? [{name:row.hbUrl,url:this.ossURL+row.hbUrl}] : []
      if (row.startDate) {
        this.validDate = [new Date(row.startDate), new Date(row.endDate)]
      }
      if (row.tyStartDate) {
        this.tyValidDate = [row.tyStartDate, row.tyEndDate]
      }

      if (row.type === '1') {
        this.formRules.storeId = []
      } else {
        this.formRules.storeId = [
          { required: true, message: '请选择门店', trigger: 'blur' }
        ]
      }
      if (row.type == '2') {
        this.formRules.tyStartDate = [
          { required: true, message: '请选择歇业时间', trigger: 'blur' }
        ]
      } else {
        this.formRules.tyStartDate = []
      }

      // 按内容类型切换必填项（海报 / 文本）
      this.handleContentTypeChange(this.activityForm.contentType)

      this.GetStore2(row.storeId)
    },
    // 删除
    handleDelete(row) {
      this.$confirm('确定要删除该活动吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$http.get('/activity/delete/' + row.id)
            .then(response => {
              if (response.data.status === 0) {
                this.$message.success('删除成功')
                this.getActivityList()
              } else {
                this.$message.error(response.data.msg || '删除失败')
              }
            })
            .catch(error => {
              console.error('删除失败:', error)
              this.$message.error('删除失败，请稍后重试')
            })
            .finally(() => {
              this.loading = false
            })
        })
        .catch(() => {
          // 用户取消删除
        })
    },

    // 提交表单
    handleSubmit() {
      this.$refs.activityForm.validate(valid => {
        if (valid) {
          // quill 空内容会产出 <p><br></p> 这类"看起来非空"的 HTML，需去标签后再判断
          if (String(this.activityForm.contentType) === '2') {
            const plainText = String(this.activityForm.content || '')
              .replace(/<[^>]*>/g, '')
              .replace(/&nbsp;/g, ' ')
              .trim()
            if (!plainText) {
              this.$message.warning('请输入弹窗文本内容')
              return false
            }
          }
          this.submitLoading = true

          if(this.validDate && this.validDate.length > 0) {
            this.activityForm.startDate = this.validDate[0]
            this.activityForm.endDate = this.validDate[1]
          }

          const url = this.activityForm.id ? '/activity/update' : '/activity/add'

          let param = {...this.activityForm}
          if (Array.isArray(param.storeId)) {
            param.storeId = param.storeId.join(',')
          }
          // 后端以数字存储：1-海报 2-文本
          param.contentType = Number(param.contentType)
          this.$http.post(url, param)
            .then(response => {
              if (response.data.code === 200) {
                this.$message.success(this.activityForm.id ? '更新成功' : '添加成功')
                this.dialogVisible = false
                this.getActivityList()
              } else {
                this.$message.error(response.data.msg || '操作失败')
              }
            })
            .catch(error => {
              console.error('操作失败:', error)
              this.$message.error('操作失败，请稍后重试')
            })
            .finally(() => {
              this.submitLoading = false
            })
        } else {
          this.$message.warning('请填写完整的表单信息')
          return false
        }
      })
    },

    // 对话框关闭
    handleDialogClose() {
      this.$refs.activityForm.resetFields()
    },

    // 每页显示数量改变
    handleSizeChange(val) {
      this.queryForm.limit = val
      this.queryForm.page = 1
      this.getActivityList()
    },

    // 当前页改变
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.getActivityList()
    },
    addPic(file){
      if (file.code == '0') {
        this.activityForm.hbUrl = file.url
      } else {
        this.$message.error(file.msg);
      }
    },
    // 删除海报时同步清空表单字段，避免出现"图片已删但 hbUrl 仍提交"的脏数据
    removePic(){
      this.activityForm.hbUrl = ''
      this.fileList = []
    },
    handleExceed(){
      this.$message.warning('只能上传一张海报，请先删除已上传的图片')
    },
    // 切换弹窗内容类型：只切换校验规则，不清空另一项已填内容（便于来回切换）
    handleContentTypeChange(val){
      if (String(val) === '2') {
        this.formRules.hbUrl = []
        this.formRules.content = [
          { required: true, message: '请输入弹窗文本内容', trigger: 'blur' }
        ]
      } else {
        this.formRules.hbUrl = [
          { required: true, message: '请上传海报', trigger: 'blur' }
        ]
        this.formRules.content = []
      }
      this.$nextTick(() => {
        if (this.$refs.activityForm) {
          this.$refs.activityForm.clearValidate(['hbUrl', 'content'])
        }
      })
    },
    // 光标处插入表情
    insertEmoji(emoji){
      const quill = this.$refs.contentEditor && this.$refs.contentEditor.quill
      if (!quill) {
        return
      }
      const range = quill.getSelection()
      const index = range ? range.index : quill.getLength()
      quill.insertText(index, emoji)
      quill.setSelection(index + emoji.length)
    },
    handleTypeChange(val) {
      this.formRules.storeId = [
        { required: true, message: '请选择门店', trigger: 'blur' }
      ]
      this.activityForm.tyStartDate = ''
      this.activityForm.tyEndDate = ''
      this.tyValidDate = []
      this.formRules.tyStartDate = []
      if (val == '1') {
        this.activityForm.storeId = []
        this.formRules.storeId = []
      } else if (val == '2') {
        this.formRules.tyStartDate = [
          { required: true, message: '请选择歇业时间', trigger: 'blur' }
        ]
      }
    },
    handleTzChange(val){
      this.formRules.cardId = []
      this.formRules.zsDay = []
      this.activityForm.cardId = null
      this.activityForm.zsDay = null
      if (val == '1') {
        this.formRules.cardId = [
          { required: true, message: '请选择会员卡', trigger: 'blur' }
        ]
        this.formRules.zsDay = [
          { required: true, message: '请输入赠送天数', trigger: 'blur' },
          { pattern: /^[1-9]\d{0,3}$/, message: '赠送天数最小1最多9999', trigger: 'blur' }
        ]
      }
    },
    beforeUpload(file) {
      // 门店弹窗必须先选门店（空数组是 truthy，需显式判断长度）
      if (this.activityForm.type === '0' &&
          (!Array.isArray(this.activityForm.storeId) || this.activityForm.storeId.length === 0)) {
        this.$message.error('指定门店类型的活动必须先选择门店，才可上传海报！');
        return false; // 返回 false 阻止上传
      }

      // 可选：还可以在这里校验文件类型、大小等
      const isValidType = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
      const isValidSize = file.size / 1024 / 1024 < 2; // 小于 2MB

      if (!isValidType) {
        this.$message.error('只能上传 JPG/PNG 格式的图片！');
        return false;
      }
      if (!isValidSize) {
        this.$message.error('图片大小不能超过 2MB！');
        return false;
      }

      return true; // 允许上传
    },
    tyChange(val){
      this.activityForm.tyStartDate = null
      this.activityForm.tyEndDate = null
      if (val) {
        this.activityForm.tyStartDate = val[0]
        this.activityForm.tyEndDate = val[1]
      }
    }
  }
}
</script>

<style scoped>
.activity-info-container {
  padding: 20px;
}

.page-header {
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0;
  font-size: 24px;
  color: #303133;
}

.query-form {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.el-table {
  background: #fff;
}

.dialog-footer {
  text-align: right;
}

.editor-box {
  width: 100%;
}

/* 富文本：固定内容区高度并内部滚动。
   注意必须显式把 min-height 归零——全局 style.css 里有 .ql-editor{min-height:300px}，
   会让内容区撑到 300px 溢出容器，盖住下方「是否跳转 / 跳转链接」等表单项。 */
.editor-box ::v-deep .ql-container {
  height: 240px;
  overflow: hidden;
}

.editor-box ::v-deep .ql-editor {
  height: 100%;
  min-height: 0;
  overflow-y: auto;
  line-height: 1.7;
}

.editor-box ::v-deep .ql-editor.ql-blank::before {
  font-style: normal;
  color: #c0c4cc;
}

/* 工具栏：压缩按钮宽度与分组间距，让 13 个按钮在 600px 弹窗内单行放下，
   避免换行后第二行只剩一个「清除格式」 */
.editor-box ::v-deep .ql-toolbar.ql-snow {
  border-color: #dcdfe6;
  padding: 6px 8px;
}

.editor-box ::v-deep .ql-toolbar.ql-snow .ql-formats {
  margin-right: 6px;
}

.editor-box ::v-deep .ql-toolbar.ql-snow button {
  width: 24px;
  padding: 2px 0;
}

.editor-box ::v-deep .ql-container.ql-snow {
  border-color: #dcdfe6;
}

/* 工具栏与内容区边框贴合，避免中间出现 2px 双层线 */
.editor-box ::v-deep .ql-toolbar.ql-snow + .ql-container.ql-snow {
  border-top: none;
}

.editor-tools {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.editor-tip {
  margin-left: 12px;
  color: #909399;
  font-size: 12px;
}

.emoji-panel {
  max-height: 180px;
  overflow-y: auto;
  line-height: 1;
}

.emoji-item {
  display: inline-block;
  width: 32px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  font-size: 20px;
  cursor: pointer;
  border-radius: 4px;
}

.emoji-item:hover {
  background: #f2f6fc;
}
</style>
